import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../dev_components/../dev_layout/AppStore.scss";
import { Icon, TopBar } from "@shopify/polaris";
import { useDispatch, useSelector } from "react-redux";
import { navlines } from '../../assets';
import { devloggedOut } from "../dev_store/slice/devAuthSlice";
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { HomeFilledIcon, AppsIcon, SettingsFilledIcon } from "@shopify/polaris-icons";

import { Box, Divider, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

type Anchor = 'top' | 'left' | 'bottom' | 'right';

export default function DevHeader() {
  const [isTabletView, setIsTabletView] = useState<boolean>(false);
  const [isMobileView, setIsMobileView] = useState<boolean>(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsTabletView(window.innerWidth <= 1024);
      setIsMobileView(window.innerWidth <= 480);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const navigate = useNavigate();
  const email_verified = useSelector((state: any) => state.devAuth.dev_email_verified);

  const toggleIsUserMenuOpen = useCallback(() => setIsUserMenuOpen((isUserMenuOpen) => !isUserMenuOpen), []);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const dispatch = useDispatch();

  const handleLogin = () => {
    navigate("/developer/login");
  };

  const first_name = useSelector((state: any) => state.devAuth.dev_first_name);
  const last_name = useSelector((state: any) => state.devAuth.dev_last_name);

  const handleLogout = () => {
    dispatch(devloggedOut());
    localStorage.clear();
    window.location.reload();
  };

  const userMenuMarkup = (
    <div className="logo-icon" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <div className="logo-user">
        <div style={{ width: "80px" }}></div>
        <TopBar.UserMenu
          actions={[
            { items: [{ content: first_name + " " + last_name }] },
            { items: [{ content: "Logout", onAction: handleLogout }] },
          ]}
          name={""}
          initials={""}
          open={isUserMenuOpen}
          onToggle={toggleIsUserMenuOpen}
          avatar="https://iili.io/JETT4gs.png"
        />
      </div>
    </div>
  );

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event.type === 'keydown' && ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const list = (anchor: Anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {['Home', 'Apps'].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton onClick={() => navigate(`/developer${text.toLowerCase() === "home" ? "" : "/" + text.toLowerCase()}`)}>
              <ListItemIcon>
                {index % 2 === 0 ? <Icon source={HomeFilledIcon} tone="base" /> : <Icon source={AppsIcon} tone="base" />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {['Settings'].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton onClick={() => navigate(`/developer/${text.toLowerCase()}`)}>
              <ListItemIcon>
                {index % 2 === 0 ? <Icon source={SettingsFilledIcon} tone="base" /> : <Icon source={SettingsFilledIcon} tone="base" />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      <Drawer
        anchor="left"
        open={state.left}
        onClose={toggleDrawer('left', false)}
      >
        {list('left')}
      </Drawer>

      <header className="devheader">
        {isTabletView || isMobileView ? (
          <div>
            <a onClick={toggleDrawer('left', true)}>
              <img height={"30px"} width={"30px"} src={navlines} alt="Logo" style={{ cursor: 'pointer' }} />
            </a>
          </div>
        ) : (
          <div className="devheader__logo">
            <a href="/developer">
              <img src="https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1719398962_developer-logo.png" alt="Logo" />
            </a>
          </div>
        )}

        {email_verified ? (
          userMenuMarkup
        ) : (
          <button className="devheader__login-button" onClick={handleLogin}>
            Login
          </button>
        )}
      </header>
    </div>
  );
}
